var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":""},on:{"click":function($event){return _vm.subscribe()}},slot:"activator"},[_c('v-icon',{attrs:{"color":"blue darken-4"}},[_vm._v("subscriptions")])],1),_c('span',[_vm._v(_vm._s(_vm.title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }